var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTourIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 702 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.529 45.9792C240.529 43.9426 242.18 42.2917 244.217 42.2917H256.508C258.545 42.2917 260.196 43.9426 260.196 45.9792C260.196 48.0157 258.545 49.6667 256.508 49.6667H244.217C242.18 49.6667 240.529 48.0157 240.529 45.9792Z",
    fill: "url(#paint0_linear_295_12686)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.946 45.9792C215.946 43.9426 217.597 42.2917 219.633 42.2917H231.925C233.962 42.2917 235.613 43.9426 235.613 45.9792C235.613 48.0157 233.962 49.6667 231.925 49.6667H219.633C217.597 49.6667 215.946 48.0157 215.946 45.9792Z",
    fill: "url(#paint1_linear_295_12686)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.529 58.2708C240.529 56.2343 242.18 54.5833 244.217 54.5833H256.508C258.545 54.5833 260.196 56.2343 260.196 58.2708C260.196 60.3074 258.545 61.9583 256.508 61.9583H244.217C242.18 61.9583 240.529 60.3074 240.529 58.2708Z",
    fill: "url(#paint2_linear_295_12686)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.946 58.2708C215.946 56.2343 217.597 54.5833 219.633 54.5833H231.925C233.962 54.5833 235.613 56.2343 235.613 58.2708C235.613 60.3074 233.962 61.9583 231.925 61.9583H219.633C217.597 61.9583 215.946 60.3074 215.946 58.2708Z",
    fill: "url(#paint3_linear_295_12686)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.529 34.667C240.529 32.6304 242.18 30.9795 244.217 30.9795H256.508C258.545 30.9795 260.196 32.6304 260.196 34.667C260.196 36.7035 258.545 38.3545 256.508 38.3545H244.217C242.18 38.3545 240.529 36.7035 240.529 34.667Z",
    fill: "url(#paint4_linear_295_12686)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.342 13.0609C266.342 12.1665 265.417 11.5715 264.603 11.9424L210.52 36.5839C210.081 36.7836 209.8 37.2208 209.8 37.7025V66.875H202.425V37.7025C202.425 34.3312 204.394 31.2705 207.462 29.8727L261.545 5.23116C267.243 2.63524 273.717 6.79991 273.717 13.0609V106.208H266.342V13.0609Z",
    fill: "url(#paint5_linear_295_12686)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.05 70.5653C195.05 69.7919 195.756 69.2107 196.515 69.3589L250.598 79.9196C251.175 80.0323 251.592 80.5379 251.592 81.126V106.208H258.967V81.126C258.967 77.0098 256.051 73.4701 252.012 72.6813L197.928 62.1206C192.615 61.0831 187.675 65.1517 187.675 70.5653V106.208H195.05V70.5653Z",
    fill: "url(#paint6_linear_295_12686)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.529 109.896C181.529 107.859 183.18 106.208 185.217 106.208H276.175C278.212 106.208 279.863 107.859 279.863 109.896C279.863 111.932 278.212 113.583 276.175 113.583H185.217C183.18 113.583 181.529 111.932 181.529 109.896Z",
    fill: "url(#paint7_linear_295_12686)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.258 93.9167C212.258 89.1647 216.111 85.3125 220.863 85.3125H225.779C230.531 85.3125 234.383 89.1647 234.383 93.9167V106.208H227.008V93.9167C227.008 93.2378 226.458 92.6875 225.779 92.6875H220.863C220.184 92.6875 219.633 93.2378 219.633 93.9167V106.208H212.258V93.9167Z",
    fill: "url(#paint8_linear_295_12686)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M407.501 202.167C405.568 202.167 404.001 203.734 404.001 205.667C404.001 207.6 405.568 209.167 407.501 209.167H428.501C430.434 209.167 432.001 207.6 432.001 205.667C432.001 203.734 430.434 202.167 428.501 202.167H407.501Z",
    fill: "url(#paint9_linear_295_12686)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M404.001 224.333C404.001 222.4 405.568 220.833 407.501 220.833H428.501C430.434 220.833 432.001 222.4 432.001 224.333C432.001 226.266 430.434 227.833 428.501 227.833H407.501C405.568 227.833 404.001 226.266 404.001 224.333Z",
    fill: "url(#paint10_linear_295_12686)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.167 195.167C384.167 188.079 389.913 182.333 397.001 182.333H439.001C446.088 182.333 451.834 188.079 451.834 195.167V276.833H461.167C463.1 276.833 464.667 278.4 464.667 280.333C464.667 282.266 463.1 283.833 461.167 283.833H374.834C372.901 283.833 371.334 282.266 371.334 280.333C371.334 278.4 372.901 276.833 374.834 276.833H384.167V195.167ZM444.834 195.167V276.833H433.167V253.5C433.167 246.412 427.422 240.667 420.334 240.667H415.667C408.58 240.667 402.834 246.412 402.834 253.5V276.833H391.167V195.167C391.167 191.945 393.779 189.333 397.001 189.333H439.001C442.222 189.333 444.834 191.945 444.834 195.167ZM409.834 276.833H426.167V253.5C426.167 250.278 423.556 247.667 420.334 247.667H415.667C412.446 247.667 409.834 250.278 409.834 253.5V276.833Z",
    fill: "url(#paint11_linear_295_12686)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M599.891 432.244C598.223 432.244 596.871 433.59 596.871 435.25C596.871 436.911 598.223 438.257 599.891 438.257L618.014 438.257C619.682 438.257 621.035 436.911 621.035 435.25C621.035 433.59 619.682 432.244 618.014 432.244H599.891Z",
    fill: "url(#paint12_linear_295_12686)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M575.728 392.159C574.06 392.159 572.708 393.505 572.708 395.165C572.708 396.826 574.06 398.171 575.728 398.171L585.797 398.171C587.465 398.171 588.817 396.826 588.817 395.165C588.817 393.505 587.465 392.159 585.797 392.159H575.728Z",
    fill: "url(#paint13_linear_295_12686)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M600.905 395.165C600.905 393.505 602.257 392.159 603.925 392.159H613.994C615.662 392.159 617.014 393.505 617.014 395.165C617.014 396.826 615.662 398.171 613.994 398.171L603.925 398.171C602.257 398.171 600.905 396.826 600.905 395.165Z",
    fill: "url(#paint14_linear_295_12686)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.686 375.125C562.569 375.125 557.611 380.06 557.611 386.148V407.379C556.443 407.654 555.355 408.223 554.459 409.044L550.081 413.052C545.356 417.38 548.432 425.229 554.853 425.229H557.611V448.279H555.599C553.931 448.279 552.579 449.625 552.579 451.285C552.579 452.946 553.931 454.292 555.599 454.292H634.131C635.799 454.292 637.151 452.946 637.151 451.285C637.151 449.625 635.799 448.279 634.131 448.279H632.115V425.229H634.883C641.305 425.229 644.381 417.38 639.655 413.052L635.277 409.044C634.378 408.221 633.287 407.651 632.115 407.377V386.148C632.115 380.06 627.157 375.125 621.04 375.125H568.686ZM569.693 448.279H563.652V425.229H626.075V448.279H591.843V438.26C591.843 432.172 586.884 427.237 580.768 427.237C574.651 427.237 569.693 432.172 569.693 438.26V448.279ZM585.802 438.26V448.279H575.733V438.26C575.733 435.493 577.987 433.249 580.768 433.249C583.548 433.249 585.802 435.493 585.802 438.26ZM626.075 407.192V386.148C626.075 383.381 623.821 381.138 621.04 381.138H568.686C565.906 381.138 563.652 383.381 563.652 386.148V407.192H626.075ZM559.23 413.204C558.978 413.204 558.735 413.299 558.549 413.469L554.171 417.477C553.496 418.095 553.936 419.217 554.853 419.217H634.883C635.801 419.217 636.24 418.095 635.565 417.477L631.187 413.469C631.002 413.299 630.758 413.204 630.506 413.204H559.23Z",
    fill: "url(#paint15_linear_295_12686)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M303 60C303 60 462.59 60 582.127 60C701.664 60 699.581 241 582.127 241H480.584",
    stroke: "#002D9C",
    strokeWidth: 61
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M303 60C303 60 462.59 60 582.127 60C701.664 60 699.581 241 582.127 241H480.584",
    stroke: "#A6C8FF",
    strokeWidth: 6,
    strokeDasharray: "18 18"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M356 241C356 241 239.41 241 119.873 241C0.336365 241 2.41925 422 119.873 422L527.5 422",
    stroke: "#002D9C",
    strokeWidth: 61
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M356 241C356 241 239.41 241 119.873 241C0.336365 241 2.41925 422 119.873 422L527.5 422",
    stroke: "#A6C8FF",
    strokeWidth: 6,
    strokeDasharray: "18 18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_295_12686",
    x1: 268.812,
    y1: -717.974,
    x2: 461.366,
    y2: -702.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_295_12686",
    x1: 268.812,
    y1: -717.974,
    x2: 461.366,
    y2: -702.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_295_12686",
    x1: 268.812,
    y1: -717.974,
    x2: 461.366,
    y2: -702.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_295_12686",
    x1: 268.812,
    y1: -717.974,
    x2: 461.366,
    y2: -702.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_295_12686",
    x1: 268.812,
    y1: -717.974,
    x2: 461.366,
    y2: -702.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_295_12686",
    x1: 268.812,
    y1: -717.974,
    x2: 461.366,
    y2: -702.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_295_12686",
    x1: 268.812,
    y1: -717.974,
    x2: 461.366,
    y2: -702.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_295_12686",
    x1: 268.812,
    y1: -717.974,
    x2: 461.366,
    y2: -702.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_295_12686",
    x1: 268.812,
    y1: -717.974,
    x2: 461.366,
    y2: -702.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_295_12686",
    x1: 454.179,
    y1: -489.538,
    x2: 636.895,
    y2: -474.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_295_12686",
    x1: 454.179,
    y1: -489.538,
    x2: 636.895,
    y2: -474.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_295_12686",
    x1: 454.179,
    y1: -489.538,
    x2: 636.895,
    y2: -474.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_295_12686",
    x1: 631.365,
    y1: -148.913,
    x2: 814.897,
    y2: -129.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_295_12686",
    x1: 631.365,
    y1: -148.913,
    x2: 814.897,
    y2: -129.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_295_12686",
    x1: 631.365,
    y1: -148.913,
    x2: 814.897,
    y2: -129.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_295_12686",
    x1: 631.365,
    y1: -148.913,
    x2: 814.897,
    y2: -129.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIllustration);
export default __webpack_public_path__ + "static/media/tour-illustration.9db050ca0f74bd327bafe3922c0846f8.svg";
export { ForwardRef as ReactComponent };